import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Row, Col, FormText } from 'reactstrap';
import { isNumber, Translate, translate, ValidatedField, ValidatedForm } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { IUser } from 'app/shared/model/user.model';
import { getUsers } from 'app/modules/administration/user-management/user-management.reducer';
import { IImportantUserDetails } from 'app/shared/model/important-user-details.model';
import { getEntity, updateEntity, createEntity, reset } from './important-user-details.reducer';

export const ImportantUserDetailsUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const users = useAppSelector(state => state.userManagement.users);
  const importantUserDetailsEntity = useAppSelector(state => state.importantUserDetails.entity);
  const loading = useAppSelector(state => state.importantUserDetails.loading);
  const updating = useAppSelector(state => state.importantUserDetails.updating);
  const updateSuccess = useAppSelector(state => state.importantUserDetails.updateSuccess);

  const handleClose = () => {
    navigate('/important-user-details' + location.search);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getUsers({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  // eslint-disable-next-line complexity
  const saveEntity = values => {
    if (values.id !== undefined && typeof values.id !== 'number') {
      values.id = Number(values.id);
    }

    const entity = {
      ...importantUserDetailsEntity,
      ...values,
      user: users.find(it => it.id.toString() === values.user.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...importantUserDetailsEntity,
          user: importantUserDetailsEntity?.user?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="fitengineerBackendV2App.importantUserDetails.home.createOrEditLabel" data-cy="ImportantUserDetailsCreateUpdateHeading">
            <Translate contentKey="fitengineerBackendV2App.importantUserDetails.home.createOrEditLabel">
              Create or edit a ImportantUserDetails
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="important-user-details-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('fitengineerBackendV2App.importantUserDetails.physicGoal')}
                id="important-user-details-physicGoal"
                name="physicGoal"
                data-cy="physicGoal"
                type="textarea"
              />
              <ValidatedField
                label={translate('fitengineerBackendV2App.importantUserDetails.height')}
                id="important-user-details-height"
                name="height"
                data-cy="height"
                type="text"
              />
              <ValidatedField
                label={translate('fitengineerBackendV2App.importantUserDetails.weight')}
                id="important-user-details-weight"
                name="weight"
                data-cy="weight"
                type="text"
              />
              <ValidatedField
                label={translate('fitengineerBackendV2App.importantUserDetails.supplementPrference')}
                id="important-user-details-supplementPrference"
                name="supplementPrference"
                data-cy="supplementPrference"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('fitengineerBackendV2App.importantUserDetails.dietPreferrence')}
                id="important-user-details-dietPreferrence"
                name="dietPreferrence"
                data-cy="dietPreferrence"
                type="text"
              />
              <ValidatedField
                label={translate('fitengineerBackendV2App.importantUserDetails.preferredNonVegDays')}
                id="important-user-details-preferredNonVegDays"
                name="preferredNonVegDays"
                data-cy="preferredNonVegDays"
                type="text"
              />
              <ValidatedField
                label={translate('fitengineerBackendV2App.importantUserDetails.wakeUpTime')}
                id="important-user-details-wakeUpTime"
                name="wakeUpTime"
                data-cy="wakeUpTime"
                type="text"
              />
              <ValidatedField
                label={translate('fitengineerBackendV2App.importantUserDetails.bedTime')}
                id="important-user-details-bedTime"
                name="bedTime"
                data-cy="bedTime"
                type="text"
              />
              <ValidatedField
                label={translate('fitengineerBackendV2App.importantUserDetails.breakfastTime')}
                id="important-user-details-breakfastTime"
                name="breakfastTime"
                data-cy="breakfastTime"
                type="text"
              />
              <ValidatedField
                label={translate('fitengineerBackendV2App.importantUserDetails.lunchTime')}
                id="important-user-details-lunchTime"
                name="lunchTime"
                data-cy="lunchTime"
                type="text"
              />
              <ValidatedField
                label={translate('fitengineerBackendV2App.importantUserDetails.dinnerTime')}
                id="important-user-details-dinnerTime"
                name="dinnerTime"
                data-cy="dinnerTime"
                type="text"
              />
              <ValidatedField
                label={translate('fitengineerBackendV2App.importantUserDetails.workoutTime')}
                id="important-user-details-workoutTime"
                name="workoutTime"
                data-cy="workoutTime"
                type="text"
              />
              <ValidatedField
                label={translate('fitengineerBackendV2App.importantUserDetails.workTime')}
                id="important-user-details-workTime"
                name="workTime"
                data-cy="workTime"
                type="text"
              />
              <ValidatedField
                label={translate('fitengineerBackendV2App.importantUserDetails.medicalHistory')}
                id="important-user-details-medicalHistory"
                name="medicalHistory"
                data-cy="medicalHistory"
                type="text"
              />
              <ValidatedField
                label={translate('fitengineerBackendV2App.importantUserDetails.allergy')}
                id="important-user-details-allergy"
                name="allergy"
                data-cy="allergy"
                type="text"
              />
              <ValidatedField
                label={translate('fitengineerBackendV2App.importantUserDetails.suggestions')}
                id="important-user-details-suggestions"
                name="suggestions"
                data-cy="suggestions"
                type="textarea"
              />
              <ValidatedField label={'Address'} id="important-user-details-address" name="address" data-cy="address" type="text" />
              <ValidatedField
                label={translate('fitengineerBackendV2App.importantUserDetails.dislikedFoods')}
                id="important-user-details-dislikedFoods"
                name="dislikedFoods"
                data-cy="dislikedFoods"
                type="text"
              />
              <ValidatedField
                label={translate('fitengineerBackendV2App.importantUserDetails.easilyAvilableFoodSources')}
                id="important-user-details-easilyAvilableFoodSources"
                name="easilyAvilableFoodSources"
                data-cy="easilyAvilableFoodSources"
                type="text"
              />
              <ValidatedField
                label="Barbell Chest Press"
                id="important-user-details-barbellChestPress"
                name="barbellChestPress"
                data-cy="barbellChestPress"
                type="text"
              />
              <ValidatedField
                label="Barbell Shoulder Press"
                id="important-user-details-barbellShoulderPress"
                name="barbellShoulderPress"
                data-cy="barbellShoulderPress"
                type="text"
              />
              <ValidatedField label="Deadlift" id="important-user-details-deadlift" name="deadlift" data-cy="deadlift" type="text" />
              <ValidatedField label="Squats" id="important-user-details-squats" name="squats" data-cy="squats" type="text" />
              <ValidatedField
                label="Barbell Biceps Curls"
                id="important-user-details-barbellBicepsCurls"
                name="barbellBicepsCurls"
                data-cy="barbellBicepsCurls"
                type="text"
              />
              <ValidatedField
                label="Hamstrings Curls"
                id="important-user-details-hamstringsCurls"
                name="hamstringsCurls"
                data-cy="hamstringsCurls"
                type="text"
              />
              <ValidatedField
                label="Tricep Cable Push Down"
                id="important-user-details-tricepCablePushDown"
                name="tricepCablePushDown"
                data-cy="tricepCablePushDown"
                type="text"
              />
              <ValidatedField
                label="Lat Pulldown"
                id="important-user-details-latpulldown"
                name="latpulldown"
                data-cy="latpulldown"
                type="text"
              />
              <ValidatedField
                label={translate('fitengineerBackendV2App.importantUserDetails.confirmationDigitalSignature')}
                id="important-user-details-confirmationDigitalSignature"
                name="confirmationDigitalSignature"
                data-cy="confirmationDigitalSignature"
                check
                type="checkbox"
              />
              <ValidatedField
                id="important-user-details-user"
                name="user"
                data-cy="user"
                label={translate('fitengineerBackendV2App.importantUserDetails.user')}
                type="select"
                required
              >
                <option value="" key="0" />
                {users
                  ? users.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.login}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/important-user-details" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default ImportantUserDetailsUpdate;
